import { Attachment } from "./attachment";
import { EditionRenditionsInfo } from "./edition-renditions-info";
import { Element } from "./element";
import { InDesignArticle } from "./indesign-article";
import { Message } from "./message";
import { MessageList } from "./message-list";
import { MetaData } from "./metadata";
import { ObjectLabel } from "./object-label";
import { ObjectOperation } from "./object-operations";
import { Page } from "./page";
import { Placement } from "./placement";
import { Relation } from "./relation";
import { Target } from "./target";

export class WflObject {
    public __classname__: string = 'Object';

    public MetaData: MetaData | null = null;

    public Relations: Relation[] | null = null;

    public Pages: Page[] | null = null;

    public Files: Attachment[] | null = null;

    public Messages: Message[] | null = null;

    public Elements: Element[] | null = null;

    public Targets: Target[] | null = null;

    public Renditions: EditionRenditionsInfo[] | null = null;

    public MessageList: MessageList | null = null;

    public ObjectLabels: ObjectLabel[] | null = null;

    public InDesignArticles: InDesignArticle[] | null = null;

    public Placements: Placement[] | null = null;

    public Operations: ObjectOperation[] | null = null;

    constructor(
        params : WflObjectNamedParameters
    ) {
        this.MetaData = params.Metadata ?? null;
        this.Relations = params.Relations ?? null;;
        this.Pages = params.Pages ?? null;;
        this.Files = params.Files ?? null;;
        this.Messages = params.Messages ?? null;;
        this.Elements = params.Elements ?? null;;
        this.Targets = params.Targets ?? null;;
        this.Renditions = params.Renditions ?? null;;
        this.MessageList = params.MessageList ?? null;;
        this.ObjectLabels = params.ObjectLabels ?? null;;
        this.InDesignArticles = params.InDesignArticles ?? null;;
        this.Placements = params.Placements ?? null;;
        this.Operations = params.Operations ?? null;;
    }

}

export interface WflObjectNamedParameters {
    Metadata?: MetaData
    Relations?: Relation[]
    Pages?: Page[]
    Files?: Attachment[]
    Messages?: Message[]
    Elements?: Element[]
    Targets?: Target[]
    Renditions?: EditionRenditionsInfo[]
    MessageList?: MessageList
    ObjectLabels?: ObjectLabel[]
    InDesignArticles?: InDesignArticle[]
    Placements?: Placement[]
    Operations?: ObjectOperation[]
}